import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from "./PercentageCalculator";
const TITLE =
  "احسب نسبة 10% من مبلغ - حاسبة 10 بالمئة الالكترونية - تعلم كم تساوي عشرة في المئة";
const DESCRIPTION =
  "تعلم كيف تقوم ب احسب نسبة 10% من مبلغ - حاسبة 10 بالمئة - حساب كم تساوي عشرة بالمئة. تقوم هذه الحاسبة بحساب قيمة ونسبة 10 بالمئة من مبلغ او قيمة معينة";
const KEYWORDS =
  "احسب نسبة 10% من مبلغ - حاسبة 10 بالمئة - حساب كم تساوي عشرة بالمئة, 10%, حساب النسبة المئوية";
const OG_URL = "https://do-calculate.com/calculator/ar/10percent/";
function Calculator() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "17px" }}>
                  لحساب نسبة 10% من قيمة معينة، يمكنك اتباع الخطوات التالية:
                </h2>
                <ul>
                  <li>
                    قم بضرب القيمة بنسبة 10% ككسر. يمكن تمثيل 10% على شكل كسر
                    على النحو التالي: 10/100.
                  </li>
                  <li>
                    بعد ذلك، قم بضرب القيمة الأصلية في النسبة المكونة من الكسر.
                    لنفترض أن لديك قيمة معينة تريد حساب 10% منها، فلنقل أن هذه
                    القيمة تساوي 100، يمكنك استخدام المعادلة التالية:
                    <br />
                    النسبة = (القيمة الأصلية × الكسر 10/100)
                  </li>
                  <li>
                    أو يمكنك ببساطة إجراء العملية الحسابية كالتالي: قسم القيمة
                    الأصلية على 20.
                    <br />
                    النسبة = القيمة الأصلية / 20
                  </li>
                  <li>ستحصل على النسبة المطلوبة، وهي 10% من القيمة الأصلية.</li>
                </ul>
                <ul>
                  تقوم هذه الحاسبة ايضا بحساب :<li>نسبة 11 بالمئة</li>
                  <li>نسبة 12 بالمئة</li>
                  <li>نسبة 13 بالمئة</li>
                  <li>نسبة 14 بالمئة</li>
                  <li>نسبة 15 بالمئة</li>
                  <li>نسبة 16 بالمئة</li>
                  <li>نسبة 17 بالمئة</li>
                  <li>نسبة 18 بالمئة</li>
                  <li>نسبة 19 بالمئة</li>
                </ul>
                <b>
                  يمكنك أيضا استخدام الحاسبة الالكترونية التالية لحساب نسبة 10
                  بالمئة من رقم او مبلغ معين:
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <PercentageCalculator percentage={10} />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
